import { call, put, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { retractBidApi } from "../../API/API";

function* retractBidSaga(params) {
    try {
        const response = yield call(retractBidApi,params.payload);
        yield put({ type: types.RETRACT_BID_SUCCESS, payload: response.data, FromMsg: params.payload.params.FromMsg? params.payload.params.FromMsg:false });
    }    
    catch (error) {
        yield put({type: types.RETRACT_BID_FAILURE, error});
    }
}

export function* watchRetractBidSaga() {
    yield takeLeading(types.RETRACT_BID_REQUESTED, retractBidSaga);
}